<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { inlineStyle } from '../../lib/utils';

  interface CssPosition {
    position: string;
    left: string;
    top: string;
    bottom: string;
    right: string;
  }

  export let src: string;
  export let fill: string = null;
  export let stroke: string = null;
  export let width: string = null;
  export let height: string = null;
  export let push: Partial<CssPosition> = null;

  let svgString = '';
  const dispatch = createEventDispatcher();
  const style = inlineStyle({
    '--svg-stroke': stroke,
    '--svg-fill': fill,
    '--svg-width': width,
    '--svg-height': height,
    ...push,
  });

  loadSvg();

  async function loadSvg() {
    const svg = await window.fetch(src);
    svgString = await svg.text();

    dispatch('loaded');
  }
</script>

{#if svgString}
  <div class="svg-wrapper" {style}>
    {@html svgString}
  </div>
{/if}

<style>
  .svg-wrapper {
    display: inline-flex;
    position: relative;
  }

  :global(.svg-wrapper > svg) {
    vertical-align: middle;
    height: var(--svg-height, auto);
    width: var(--svg-width, auto);
  }
</style>
